import { LineChartConfig } from 'components/chart/data/LineChartConfig';
import { BarChartConfig } from 'components/chart/data/BarChartConfig';
import { ChartDataArray } from 'components/chart/data/ChartDataArray';
import { ChartDataType } from 'components/chart/data/ChartDataType';
import { ChartData } from 'components/chart/data/ChartData';
import { MeasureUnitCode } from 'components/measure-unit/MeasureUnitCode';
import { IntlShape } from 'react-intl';
import { Model } from 'pages/Benchmarking/performance/model';
import { Measure } from 'services/model/model.service';
import { chartColors } from 'styles/configs/chartColors';
import { calcGrowth } from 'utils/calc';

export function createTimeSeriesChartConfig(
  performance: Model,
  measure: Measure,
  tenantName: string,
  benchmark: string,
  intl: IntlShape
) {
  const config = new LineChartConfig();
  config.value = {
    code: measure.code,
    label: measure.metric.name,
    unit: measure.metric.unit,
  };
  config.legendConfig = { hide: false };
  config.data = [
    new ChartDataArray(
      ChartDataType.primary,
      tenantName,
      performance.timeSeries.map(e => new ChartData(e.label, e.tenantValue))
    ),
    new ChartDataArray(
      ChartDataType.secondary,
      intl.formatMessage({ id: `benchmarking.benchmarks.${benchmark}` }),
      performance.timeSeries.map(e => new ChartData(e.label, e.benchmarkValue))
    ),
  ];
  config.data[0].color = chartColors.TENANT;
  config.data[1].color = chartColors.PEER;
  return config;
}

export function createGrowthSeriesChartConfig(
  performance: Model,
  tenantName: string,
  benchmark: string,
  intl: IntlShape
): BarChartConfig {
  const config = new BarChartConfig();
  config.value = {
    code: 'growth',
    label: intl.formatMessage({ id: 'benchmarking.tooltip.growth' }),
    unit: MeasureUnitCode.PERCENT,
  };
  config.legendConfig = { hide: false };

  const calculateGrowthRate = (current: number | null | undefined, previous: number | null | undefined): number => {
    if (current == null || previous == null) {
      console.warn('Missing data for growth calculation, returning 0.', { current, previous });
      return 0;
    }

    const growth = calcGrowth(current, previous);

    if (Number.isNaN(growth) || !Number.isFinite(growth)) {
      return 0;
    }

    return growth;
  };

  config.data = [
    new ChartDataArray(
      ChartDataType.primary,
      tenantName,
      performance.timeSeries.map(e => new ChartData(e.label, calculateGrowthRate(e.tenantValue, e.tenantCompareValue)))
    ),
    new ChartDataArray(
      ChartDataType.secondary,
      intl.formatMessage({ id: `benchmarking.benchmarks.${benchmark}` }),
      performance.timeSeries.map(
        e => new ChartData(e.label, calculateGrowthRate(e.benchmarkValue, e.benchmarkCompareValue))
      )
    ),
  ];
  config.data[0].color = chartColors.TENANT;
  config.data[1].color = chartColors.PEER;
  return config;
}
